export const communityInfoUsersMeEndpoint =
  'player-ms/player/community-info/users/me';
